import cfetch from "cross-fetch";
import {
  receiveEndpoint,
  requestEndpoint,
  invalidateEndpoint
} from "./endpoints";
import { getEndpointCount } from "./pages";
import changeMain from "../actions/main";
// import editForm from './form'
import { REST_API } from "./constants";
import { log } from "util";
import moment from "moment";

const encodeQuery = function(param) {

  let data = btoa(param);
  let part1 = data.substr(0, 25);
  let part2 = data.substr(25);

  let reverse = part2 + part1

  let final = btoa(reverse);

  return final    
}

/**
 *
 * @param {number} id - id of endpoint
 * @param {string} endpoint - endpoint name
 * @param {string} token - auth token
 * @param {string} queryStr - query string
 */
export function fetchEndpoint(id, endpoint, token, queryStr = "") {
  return dispatch => {
    dispatch(requestEndpoint(id));

    return cfetch(
      `${REST_API}/${endpoint}?${queryStr}&access_token=${token}`
    ).then(response => {
      let json = response.json().then(json => {
        let err = !Array.isArray(json);
        if (err) {
          dispatch(invalidateEndpoint(id));
          dispatch(
            changeMain({
              endpointId: id,
              endpointListId: null,
              type: "error",
              data: json
            })
          );
        } else {
          dispatch(receiveEndpoint(id, json));
        }

        return json;
      });

      return {
        response: response,
        json: json
      };
    });
  };
}

/**
 *
 * @param {Object} state
 * @param {number} id
 * @returns {boolean}
 */
function shouldFetchEndpoint(state, id) {
  const endpoint = state.endpoints.find(endpoint => endpoint.id === id);

  if (!endpoint) {
    return true;
  } else if (endpoint.isFetching) {
    return false;
  } else {
    return endpoint.didInvalidate;
  }
}

/**
 * @description calls shouldFetchEndpoint first before calling fetchEndpoint
 * @param {number} id - endpoint id to fetch
 * @param {boolean} force - force a fetch, defaults to false
 */
export function fetchEndpointIfNeeded(id, force = false) {
  return (dispatch, getState) => {
    let state = getState();
    //console.log('STATE STATE',state)
    var dateFilterValue = state.dateFilter
    let endpoint = state.endpoints.find(endpoint => endpoint.id === id);
    let epn = endpoint.name;
    let tkn = state.auth.access_token;

    let finalFilter = endpoint.apiFilter;
    let countFilter = finalFilter ? { ...finalFilter } : {};    

    if (endpoint.apiPaged) {
      if (!finalFilter) finalFilter = {};

      let whereFilter = {};

      for (let filterName in endpoint.filter) {
        //console.log('endpoint.filter[filterName].type',filterName)
        endpoint.filter[filterName].value1 =
          typeof endpoint.filter[filterName].value1 != "number" && endpoint.filter[filterName].type != 'dateTime'
            ? endpoint.filter[filterName].value1.trim()
            : endpoint.filter[filterName].value1;
        if (
          endpoint.filter[filterName].type === "string" &&
          endpoint.filter[filterName].value1 !== ".*" &&
          endpoint.name === "messagequeues"
        ) {
          if (endpoint.filter[filterName].value1.length < 3) {
            whereFilter[filterName] = endpoint.filter[filterName].value1;
          } else if (endpoint.filter[filterName].value1.length >= 3) {
            whereFilter[filterName] = {
              like: `${endpoint.filter[filterName].value1}%`
            };
          }
        } else if (
          endpoint.filter[filterName].type === "string" &&
          endpoint.filter[filterName].value1 !== ".*"
        ) {
          whereFilter[filterName] = endpoint.filter[filterName].exact
            ? endpoint.filter[filterName].value1
            : { like: `%${endpoint.filter[filterName].value1}%` };
        } else if (
          endpoint.filter[filterName].type === "reference" &&
          endpoint.filter[filterName].value1 !== ""
        ) {
          whereFilter[filterName] = Number(endpoint.filter[filterName].value1);
        } else if (
          endpoint.filter[filterName].type === "enum" &&
          endpoint.filter[filterName].value1 !== ""
        ) {
          if (endpoint.filter[filterName].value1 == 1) {
            whereFilter[filterName] = { between: [0, 99] };
          } else if (endpoint.filter[filterName].value1 == 0) {
            whereFilter[filterName] = { between: [-1, 100] };
          } else {
            whereFilter[filterName] = endpoint.filter[filterName].value1;
          }
        } else if (
          endpoint.filter[filterName].type === "queueEnum" &&
          endpoint.filter[filterName].value1 !== ""
        ) {
          whereFilter[filterName] = endpoint.filter[filterName].value1;
        } else if (
          endpoint.filter[filterName].type === "strEnum" &&
          endpoint.filter[filterName].value1 !== ".*"
        ) {
          whereFilter[filterName] = endpoint.filter[filterName].value1;
        } 
        // else if (
        //   endpoint.filter[filterName].type === "dateTime" && endpoint.filter[filterName].value1 !=''
        // ) {
        //   if(epn == 'messagequeues'){
        //     console.log('dateFilterValue',dateFilterValue.dateValue)
        //     let reFormatDate = dateFilterValue.dateValue[0];
        //     let reFormatDate1 = dateFilterValue.dateValue[1];
        //     let startDate = moment(reFormatDate).format(
        //       "YYYY-MM-DD"
        //     );
            
        //     let endDate = moment(reFormatDate).add('days', 1)
        //     let finalStartDate = moment(reFormatDate).subtract('days', 1)
        //     let finalEndDate = moment(reFormatDate1).add('days', 1)

        //     endDate = moment(endDate).format("YYYY-MM-DD")
            
        //     whereFilter[filterName] = { between: [finalStartDate, finalEndDate] };
        //   }
        // }
      }

      //EXCLUSIVE FOR DATE FILTER
      //CHECK IF THERE IS DATE FILTER VALUE ON STORE
      if (dateFilterValue.dateValue) {
        if(epn == 'messagequeues'){
          let reFormatDate = dateFilterValue.dateValue[0];
          let reFormatDate1 = dateFilterValue.dateValue[1];
          let startDate = moment(reFormatDate).format(
            "YYYY-MM-DD"
          );
          
          let endDate = moment(reFormatDate).add('days', 1)
          let finalStartDate = moment(reFormatDate)
          let finalEndDate = moment(reFormatDate1).add(1, 'days')

          endDate = moment(endDate).format("YYYY-MM-DD")
          // whereFilter['updated_at'] = { between: [finalStartDate, finalEndDate] };
          // whereFilter['updated_at'] = { between: [new Date(reFormatDate), new Date(reFormatDate1)] };
          var isSame = moment(reFormatDate).isSame(reFormatDate1)
          if(isSame){
            //console.log('DATE DATE DATE', [startDate, finalEndDate])
            //whereFilter['updated_at'] = { between: [finalStartDate, finalEndDate] };
            whereFilter['updated_at'] = { between: [startDate + "T00:00:00", startDate + "T23:59:59"] };
          }else{

            if (reFormatDate1.toUpperCase() == "INVALID DATE") {

              reFormatDate1 = reFormatDate
            }
            whereFilter['updated_at'] = { between: [reFormatDate + "T00:00:00" , reFormatDate1 + "T23:59:59"] };
          }
        }
      }

      finalFilter.where = whereFilter;
      countFilter = whereFilter;

      if (endpoint.name != "schedules") {
        finalFilter.limit = endpoint.itemsPerPage;
      }
      finalFilter.skip = endpoint.currentListPage * endpoint.itemsPerPage || 0;
    } else {

      if (epn == "users") {

        if (document.location.pathname.indexOf("/users") != -1) {

          if (!finalFilter) {

            finalFilter = {}
          }

          finalFilter["where"] = {
            'email': { 
                'nin':  ["super@excelym.com", "admin@excelym.com", "superadmin.io@excelym.com"] 
            }
          }

          let email_filter = endpoint.filter["email"]

          if (email_filter && (email_filter.value1 != ".*")) {

            countFilter = {
              and: [   
                {        
                  email: {
                    like: `%${email_filter.value1}%`
                  }
                },
                {
                  email: {
                    nin:  ["super@excelym.com", "admin@excelym.com", "superadmin.io@excelym.com"]
                  }
                }
              ]
            }
          } else {

            countFilter = {
              email: {
                nin:  ["super@excelym.com", "admin@excelym.com", "superadmin.io@excelym.com"]
              }
            }
          }     
        }
      }
    }

    let apiFilter = finalFilter ? "filter=" + encodeQuery(JSON.stringify(finalFilter)) : "";
    let countFilterStr = countFilter
      ? "where=" + encodeQuery(JSON.stringify(countFilter))
      : "";
    if (shouldFetchEndpoint(state, id) || force) {
      return dispatch(fetchEndpoint(id, epn, tkn, apiFilter)).then(() => {
        return dispatch(getEndpointCount(id, epn, tkn, countFilterStr));
      });
    } else {
      return new Promise((resolve, reject) => {
        // since fetching was already done,
        // create a fake response with the appropriate fetched data
        let returnObj = {
          response: { ok: true },
          json: new Promise(resolve => {
            resolve(epn.list);
          })
        };
        resolve(returnObj);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/fetch.js